import {
  complianceDiretrixService,
  type DiretrixQuoteEngineDataResponse,
} from '@/services/compliance-diretrix';
import { useQuery } from '@tanstack/react-query';

/**
 * Consulta os dados de motor de cotação da Diretrix (Compliance API,
 * `POST /diretrix/quote-engine-data`) para um CNPJ — em PARALELO ao lookup
 * do Brasil API. O que interessa ao PME: `averagePartnerAge` e
 * `averageEmployeeAge`, persistidos no PolicyCustomer (mesmo padrão do
 * Capital Global).
 *
 * Best-effort: falha aqui NÃO bloqueia o fluxo do Step 1 (o corretor segue
 * sem as idades médias; o back simplesmente não grava os campos).
 *
 * @param cnpj normalizado (14 caracteres — numérico ou alfanumérico RFB, sem máscara) ou `undefined` para desabilitar
 */
export function useDiretrixQuoteEngine(cnpj: string | undefined) {
  return useQuery<DiretrixQuoteEngineDataResponse | null>({
    queryKey: ['services', 'diretrix-quote-engine', cnpj],
    queryFn: async () => {
      if (!cnpj) return null;
      const response = await complianceDiretrixService.getQuoteEngineData({
        cnpj,
      });
      if (!response.success || !response.data) {
        throw new Error(response.error ?? 'Erro ao consultar Diretrix');
      }
      return response.data;
    },
    enabled: !!cnpj && cnpj.length === 14,
    retry: false,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
